/****************************************************
 * Module Name:  invoiceDetail.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import ReportProxy from "../../utility/proxy/manager/reportProxy";
import Modal from "react-bootstrap/Modal";
import { Stack, } from "@mui/material";
import Constants from "../../utility/constants";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import "./../../style/modalstyle.css";
import CommonSnackbar from "./commonSnackBar";
import StoneDetailModal from "./stoneDetailModal";
import logo from '../../images/pansuriya.jpg'
import { BsFilePdf } from "react-icons/bs";
import PDFModal from "./pdfModal";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.tableLayouts = {
    Mylayout: {
        fillColor: function (rowIndex, node, columnIndex) {
            return rowIndex % 2 === 0 ? "#CCCCCC" : null;
        },
    },
};


const InvoiceDetail = ({ invoiceId, handleClose, show, customerid, customer }) => {
    const [data, setData] = useState([]);
    const [errorSnackbar, setErrorSnackbar] = useState(false);
    const [detailLoader, setDetailLoader] = useState(false);
    const [mainData, setMainData] = useState([]);

    const [stoneId, setStoneId] = useState("");
    const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);
    const [pdfName, setPdfName] = useState("");
    const [pdfByte, setPdfByte] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        handleSearch(invoiceId);
    }, []);

    const downloadPDF = (invoiceid, fileBytes) => {
        setPdfByte(fileBytes);
        setPdfName(`Invoice` + invoiceid + `.pdf`);
        openModal()
    }

    const handleSearch = (invoiceId) => {
        if (customer) {
            setDetailLoader(true);
            ReportProxy.GetSingleCustomerWisePendingPayment(customerid, (response) => {
                if (response) {
                    setData(response);
                    setDetailLoader(false);
                    handleArray(response);
                } else {
                    setDetailLoader(false);
                    setErrorSnackbar(true);
                }
            }
            );
        } else {
            setDetailLoader(true);
            ReportProxy.GetSingleInvoiceDetail(invoiceId, (response) => {
                if (response) {
                    setData(response);
                    setDetailLoader(false);
                    handleArray(response);
                } else {
                    setDetailLoader(false);
                    setErrorSnackbar(true);
                }
            }
            );
        }
    };

    const handleArray = (lListData) => {
        let newMainData = [];
        if (lListData.length > 0) {
            lListData.map((list) => {
                list.stones.map((stone) =>
                    newMainData.push({
                        invoiceid: stone.invoiceid,
                        stoneid: stone.stoneid,
                        stoneprice: stone.stoneprice,
                        discount: stone.actualdiscount,
                        discountprice: stone.discountprice,
                        originalprice: stone.originalprice,
                        status: stone.stonedetail.status,
                        clarity: stone.stonedetail.clarity,
                        color: stone.stonedetail.color,
                        country: stone.stonedetail.country,
                        cut: stone.stonedetail.cut,
                        cutpolsym: stone.stonedetail.cutpolsym,
                        flo: stone.stonedetail.flo,
                        lab: stone.stonedetail.lab,
                        location: stone.stonedetail.location,
                        locationid: stone.stonedetail.locationid,
                        pol: stone.stonedetail.pol,
                        quality: stone.stonedetail.quality,
                        shade: stone.stonedetail.shade,
                        shape: stone.stonedetail.shape,
                        size: stone.stonedetail.size,
                        exchangerate: list.exchangerate,
                        exchangecurrency: list.exchangecurrency,
                        shippingcost: list.shippingcost,
                    })
                );
                return true;
            });
        }
        setMainData(newMainData);
    };

    const materialColumns = [
        {
            headerName: "INVOICE ID",
            field: "id",
            headerAlign: "center",
            width: 100,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "USER",
            field: "userid",
            headerAlign: "center",
            width: 90,
            align: "center",
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.userid} | ${params.row.username}`}
                        </span>
                    </div>
                );
            }
        },
        {
            headerName: "BROKER",
            field: "brokerid",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.brokerid} | ${params.row.brokername}`}
                        </span>
                    </div>
                );
            }
        },
        {
            headerName: "CUSTOMER",
            field: "customerid",
            headerAlign: "center",
            width: 230,
            align: "center",
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.customerid} | ${params.row.customername}`}
                        </span>
                    </div>
                );
            }
        },
        {
            headerName: "COMPANY",
            field: "tradingcompanyid",
            headerAlign: "center",
            width: 230,
            align: "center",
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
                        </span>
                    </div>
                );
            }
        },
        {
            headerName: "BANK THROUGH",
            field: "bankthrough",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: (params) =>
                params.row.bankthrough ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
        },
        {
            headerName: "COUNTRY OF FINAL DESTINATION",
            field: "countryoffinaldestination",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "COUNTRY OF ORIGIN",
            field: "countryoforigin",
            align: "center",
            headerAlign: "center",
            width: 150,
            renderCell: renderCellExpand,
        },
        {
            headerName: "DATE",
            field: "date",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.date),
        },
        {
            headerName: "ENSURED BY",
            field: "ensuredby",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "EXCHANGE CURRENCY",
            field: "exchangecurrency",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "EXCHANGE RATE",
            field: "exchangerate",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "EXPORT",
            field: "export",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: (params) =>
                params.row.export ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
        },
        {
            headerName: "FINAL DESTINATION",
            field: "finaldestination",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "FINAL PAYABLE AMOUNT",
            field: "finalpayableamount",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "PORT OF DISCHARGE",
            field: "portofdischarge",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "PORT OF LANDING",
            field: "portofloading",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "REMARKS",
            field: "remarks",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "SHIPPED BY",
            field: "shippedby",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        {
            headerName: "SHIPPING COST",
            field: "shippingcost",
            headerAlign: "center",
            width: 150,
            align: "center",
            renderCell: renderCellExpand,
        },
        { headerName: "TERMS", field: "terms", align: "center", renderCell: renderCellExpand },
        { headerName: "DAYS", field: "days", align: "center", renderCell: (params) => params.value },
        {
            headerName: "DUE DATE",
            field: "duedate",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: (params) => Utility.ConvertUtcToLocalDate(params.row.duedate),
        },
        {
            headerName: "PDF",
            field: "invoicepdf",
            headerAlign: "center",
            width: 80,
            align: "center",
            renderCell: (params) => (
                <BsFilePdf size={25} color="red" onClick={() => downloadPDF(params.row.id, params.row.invoicepdf)} />
            ),
            export: false,
        },
    ];

    const columnName = [
        {
            field: "invoiceid",
            headerName: "INVOICE ID",
            headerAlign: "center",
            width: 180,
            align: "center",
        },
        {
            field: "stoneid",
            headerName: "STONEID",
            headerAlign: "center",
            width: 180,
            align: "center",
            renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
                <Button
                    sx={{ textDecorationLine: "underline" }}
                    onClick={() => handleStoneDetailModal(params)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "stoneprice",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "discount",
            headerName: "DIS",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "discountprice",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
        {
            field: "originalprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: renderCellExpand,
        },
    ];
    const handleStoneDetailModal = (params) => {
        setStoneId(params.value);
        setShowStoneDetailModal(true);
    };
    const columns = columnName;

    const getDetailPanelHeight = React.useCallback(() => 515, []);

    const getDetailPanelContent = React.useCallback(
        (row, mainData) => <DetailPanelContent row={row} mainData={mainData} />,
        [],
    );

    function DetailPanelContent({ row: rowProp, mainData }) {
        const detailRows = mainData.filter((data) => data.invoiceid === rowProp.id);
        return (
            <Stack
                sx={{ py: 2, height: '50%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        color: '#000',
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                    }}
                >
                    <DataGridPro
                        disableRowSelectionOnClick={false}
                        density="compact"
                        columns={columns}
                        rows={detailRows}
                        getRowId={(row) => row.stoneid}
                        sx={{
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'grey',
                            },
                            bgcolor: "#cfd8dc",
                            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                        }}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: Constants.pageSize,
                            },
                        }}
                        pageSizeOptions={Constants.pageSizeOptions}
                        pagination
                    />
                </Box>
            </Stack>
        );
    }

    return (
        <div>
            {showStoneDetailModal ? (
                <StoneDetailModal
                    show={showStoneDetailModal}
                    stoneId={stoneId}
                    handleClose={() => setShowStoneDetailModal(false)}
                />
            ) : null}
            <CommonSnackbar
                show={errorSnackbar}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setErrorSnackbar(false)}
            />
            {/*need to send pdf in byte string to modal */}
            <PDFModal show={isModalOpen} onHide={closeModal} pdfByteString={pdfByte} pdfName={pdfName} />

            <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Invoice Detail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box px={1} mt={4}>
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .lavenderCell": {
                                    color: "#080808",
                                    backgroundColor: "#D8BFD8",
                                },
                                height: "65vh",
                            }}
                        >

                            <DataGridPro
                                disableRowSelectionOnClick={false}
                                density="compact"
                                columns={materialColumns}
                                rows={data}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "4px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "12px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "18px",
                                    },

                                    '& .MuiDataGrid-row': {
                                        whiteSpace: 'nowrap',
                                    },
                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                                initialState={{
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                getDetailPanelHeight={getDetailPanelHeight}
                                getDetailPanelContent={({ row }) => getDetailPanelContent(row, mainData)}
                            />
                            <Box
                                style={{
                                    position: "absolute",
                                    top: 5,
                                    right: "270px",
                                    display: "flex",
                                    flexWrap: "nowrap",
                                }}
                            >
                                {detailLoader ? (
                                    <CircularProgress size="1rem" />
                                ) : (
                                    <Tooltip title="Reload List">
                                        <RefreshOutlinedIcon
                                            onClick={() => handleSearch(invoiceId)}
                                            color="primary"
                                            fontSize="medium"
                                            sx={{ cursor: "pointer" }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default InvoiceDetail;
